import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Header = ({ user, onLogout, sidebarCollapsed, onToggleSidebar }) => {
  const location = useLocation();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [recordingStatus, setRecordingStatus] = useState('idle'); // idle, recording, processing

  // Update time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // Get page title based on current route
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Dashboard';
      case '/record':
        return 'AI Scribe';
      case '/templates':
        return 'Template Management';
      case '/settings':
        return 'Settings';
      default:
        return 'Chartara Notes';
    }
  };

  // Get page description based on current route
  const getPageDescription = () => {
    switch (location.pathname) {
      case '/':
        return 'Overview of your recent activity and statistics';
      case '/record':
        return 'Speak your session notes — AI handles the rest';
      case '/templates':
        return 'Manage note templates and formatting preferences';
      case '/settings':
        return 'Configure application settings and preferences';
      default:
        return 'AI-Powered Voice Documentation';
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'long',
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm h-16">
      <div className="flex items-center justify-between h-full px-6">
        
        {/* Left - Date and Time */}
        <div className="flex items-center gap-6">
          <div className="text-gray-700">
            <span className="text-xl font-semibold">{formatTime(currentTime)}</span>
            <span className="text-xl text-gray-500 ml-3">{formatDate(currentTime)}</span>
          </div>
        </div>

        {/* Right - User and Logout */}
        <div className="flex items-center gap-6">
          <span className="text-xl font-semibold text-gray-800">
            {user?.name || 'Dr. Sarah Johnson'}
          </span>
          <button
            onClick={onLogout}
            className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-900 rounded-md border border-gray-300 text-xs font-medium transition-all duration-200"
            title="Logout"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Secondary Header for Recording Page */}
      {location.pathname === '/record' && (
        <div className="bg-gray-50 border-b border-gray-200 px-lg py-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-md">
              <span className="text-sm text-gray-600">Ready to record</span>
              <div className="flex items-center gap-xs">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span className="text-xs text-gray-500">Microphone connected</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Progress Bar for Processing */}
      {recordingStatus === 'processing' && (
        <div className="h-1 bg-gray-200">
          <div className="h-full bg-primary-600 transition-all duration-300" style={{ width: '45%' }}></div>
        </div>
      )}
    </header>
  );
};

export default Header;